import { DateTimeFactory } from "../../../../../../localization/useDateTime"
import { BookingTimeType,
    ClosingTime,
    ClosingTimeType,
    CreateRoomResource,
    CreateRoomResourceForm,
    IntegrationType,
} from "../../resourcesTypes"

export const transformRoomFormToResource = (
    form: CreateRoomResourceForm,
    dateTimeFactory: DateTimeFactory,
): CreateRoomResource => {
    const { closingTimesDaily, bookingTime, integrationType, bookingTimeType, integrationEmailAddress, ...rest } = form
    const isAcceptBooking = bookingTimeType === BookingTimeType.ACCEPT_BOOKING_TIME
    const isBlockBooking = bookingTimeType === BookingTimeType.BLOCK_BOOKING_TIME

    const periodClosingTimes = form.closingTimes.filter((time) => time.type !== ClosingTimeType.DAILY)
    const dailyClosingTime: ClosingTime[] =
        isBlockBooking && closingTimesDaily
            ? [
                  {
                      type: ClosingTimeType.DAILY,
                      periodInTime: {
                          from: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.from),
                          to: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.to),
                      },
                  },
              ]
            : []
    const closingTimes = [...periodClosingTimes, ...dailyClosingTime]

    const integrations =
        integrationType !== IntegrationType.NONE
            ? [
                  {
                      type: integrationType,
                      emailAddress: integrationEmailAddress,
                  },
              ]
            : []

    return {
        ...rest,
        closingTimes,
        integrations,
        bookingTime:
            isAcceptBooking && bookingTime
                ? {
                      periodInTime: {
                          from: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.from),
                          to: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.to),
                      },
                  }
                : undefined,
    }
}
